type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({ eyebrow, title, desc, align = "center" }: SectionHeadingProps) {
  const alignment = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col max-w-2xl ${alignment}`}>
      <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-bold">
        <i className="ri-price-tag-3-line" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading font-black text-2xl md:text-4xl leading-tight text-foreground-950">
        {title}
      </h2>
      {desc && <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}